module.exports = __webpack_public_path__ + "img/parachico.540c96bc.jpg";